import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { TypedDocumentNode, FetchResult } from '@apollo/client';
import Styled from 'styled';

import Avatar from 'four-nets/avatar/avatar';
import EnhancedText from 'four-nets/ui/enhanced-text/enhanced-text';
import { displayedName } from 'four-nets/user/utils';

import Footer from './footer/footer';
import Image from './image/image';
import defaultStyles from './comment.scss';
import { CommentFragment } from './comment.graphql';
import isPrArticleUsername from 'four-nets/common/is-pr-article-username';

export interface Props extends CommentFragment {
    onComment?: (props: CommentFragment) => void;
    styles: typeof defaultStyles;
}

class Comment extends React.PureComponent<Props> {
    onComment = () => {
        if (this.props.onComment) {
            this.props.onComment(this.props);
        }
    };

    render() {
        const { styles, id, user, author, createdTime, comment, images, post, ...rest } = this.props;
        const postAutorId = post && post.user && post.user.id;
        const isVendor = user && user.profile && user.profile.isVendor;
        const vendor = user && user.profile && user.profile.vendor;

        let groupId;
        if (post && post.group && post.group.id) {
            groupId = post.group.id;
        }

        let usernameEl;
        if (user) {
            const userBlogLink = isVendor ? `/catalog/vendor/${user.username}/` : `/blog/${user.username}/`;
            const username = isVendor && vendor && vendor.name ? vendor.name : displayedName(user);

            usernameEl = (
                <Link to={userBlogLink} className={styles.username}>
                    {username}
                </Link>
            );
        } else {
            usernameEl = (
                <span className={styles.authorName}>
                    {author} (<FormattedMessage id='NOT_LOGGED' />)
                </span>
            );
        }

        return (
            <div className={styles.comment}>
                <div className={styles.authorWrapper}>
                    <Avatar style={{ avatar: styles.avatar }} user={user} />
                </div>
                <div className={styles.content}>
                    {usernameEl}
                    {isVendor ? <div className={styles.pro}>PRO</div> : null}
                    {user && postAutorId === user.id ? (
                        <div className={styles.role}>
                            <FormattedMessage id='AUTHOR' />
                        </div>
                    ) : null}
                    <span className={styles.textContent}>
                        <EnhancedText
                            followLink={
                                user?.profile.vendor?.isPresentationPaid || isPrArticleUsername(user?.username || '')
                            }
                            hashtags={true}
                            groupId={groupId}
                        >
                            {comment || ''}
                        </EnhancedText>
                    </span>
                    {images && images.edges ? (
                        <ul className={styles.images}>
                            {images.edges.map(edge =>
                                edge && edge.node ? (
                                    <li className={styles.image}>
                                        <Image
                                            sizes={{
                                                xs: 150,
                                                md: 230,
                                            }}
                                            {...edge.node}
                                        />
                                    </li>
                                ) : null
                            )}
                        </ul>
                    ) : null}
                    <Footer {...rest} post={post} createdTime={createdTime} onComment={this.onComment} id={id} />
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Comment);
